var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index-counter",class:_vm.colorClass},[_vm._v(_vm._s(_vm.padZeroes(_vm.index + 1))+" of "+_vm._s(_vm.padZeroes(_vm.count)))])}
var staticRenderFns = []

export { render, staticRenderFns }